const mapsPath = '/assets/cartes/original/';
const miniPath = '/assets/cartes/mini/';
const partnersPath = '/assets/partners/';
const tweetId = '1325373707880173577';
const homeCartes = [
  {
    name: "Fronts & frontières dans l'espace du Cône Sud",
    caption: 'Carte scolaire de géographie',
    src: `${mapsPath}frontsfrontieres2.jpg`,
    preview: `${miniPath}frontsfrontieres2.jpg`,
    tags: ['recherche'],
  },
  {
    name: 'Puy Mary',
    caption: 'Essai de carte topographique avec pour sujet un sommet des monts du Cantal ',
    src: `${mapsPath}puymary2.jpg`,
    preview: `${miniPath}puymary2.jpg`,
    tags: ['tourisme'],
  },
  {
    name: 'Découvrez Lens-Liévin à vélo !',
    caption: 'Réalisation de 4 plans parcours vélo pour l\'Office de Tourisme de Lens-Liévin',
    src: `${mapsPath}mockup_plans_lens_accueil.jpg`,
    preview: `${miniPath}mockup_plans_lens_accueil.jpg`,
    tags: ['tourisme'],
  },
  {
    name: 'Calais victorien 2020',
    caption: 'Plan de Calais "à l\'ancienne" vendu en poster dans différentes boutiques de la ville',
    src: `${mapsPath}carte_calais_2020.jpg`,
    preview: `${miniPath}carte_calais_2020.jpg`,
    tags: ['tourisme', 'calais'],
  },
  {
    name: 'Cartographie ornementale en bois',
    caption: 'Plan de Calais en bois, réalisé avec les ébénistes Simon Bouckson et Arnaud Malras, pour la Fabrique Coopérative Calaisienne La Timbale',
    src: `${mapsPath}calais_bois_abj.jpg`,
    preview: `${miniPath}calais_bois_abj.jpg`,
    tags: ['calais'],
  },
];
const tags = ['édition', 'recherche', 'journalisme', 'géopolitique', 'tourisme', 'urbanisme & architecture', 'dataviz', 'calais', 'confinement'];
const partners = [
  {
    name: 'lettres',
    src: `${partnersPath}lettres.svg`,
  },
  {
    name: 'autrement',
    src: `${partnersPath}autrement.svg`,
  },
  {
    name: 'jeune_afrique',
    src: `${partnersPath}jeune_afrique.svg`,
  },
  {
    name: 'africa_report',
    src: `${partnersPath}africa_report.svg`,
  },
  {
    name: 'transdev',
    src: `${partnersPath}transdev.svg`,
  },
  {
    name: 'lens_lievin',
    src: `${partnersPath}lens_lievin.svg`,
  },
  {
    name: 'ulco',
    src: `${partnersPath}ulco.svg`,
  },
  {
    name: 'uni_lille',
    src: `${partnersPath}uni_lille.svg`,
  },
  {
    name: 'corem',
    src: `${partnersPath}corem.svg`,
  },
  {
    name: 'gouvernail',
    src: `${partnersPath}gouvernail.svg`,
  },
  {
    name: 'lalettura',
    src: `${partnersPath}lalettura.svg`,
  },
  {
    name: 'popsu',
    src: `${partnersPath}popsu.svg`,
  },
  {
    name: 'bdc',
    src: `${partnersPath}bdc.svg`,
  },
  {
    name: 'geo',
    src: `${partnersPath}geo.svg`,
  },
];

export default Object.freeze(
  {
    tags,
    homeCartes,
    tweetId,
    partners,
    cartes: [
      {
        name: 'Géopolitique du rail',
        caption: '<a href=https://www.autrement.com/geopolitique-du-rail/9782746762329>Géopolitique du rail</a> d\'Antoine Pecqueur aux éditions Autrement',
        src: `${mapsPath}AUT_abj.jpg`,
        preview: `${miniPath}AUT_abj.jpg`,
        tags: ['édition', 'géopolitique'],
      },
      {
        name: 'Couverture de The Cartographic Journal',
        caption: 'The Cartographic Journal - Carte de confiné discutée et analysée dans <a href="https://www.tandfonline.com/doi/full/10.1080/00087041.2020.1855001">l’éditorial</a> par Alexander J. Kent',
        src: `${mapsPath}Cartographic_Journal_abj.jpg`,
        preview: `${miniPath}Cartographic_Journal_abj.jpg`,
        tags: ['édition', 'recherche', 'calais', 'confinement'],
      },
      {
        name: 'Dataviz pour La Lettura',
        caption: 'Infographie sur l\'industrie culturelle en Europe lors du confinement pour La Lettura - Corriere della Sera',
        src: `${mapsPath}LL_infog_abj.jpg`,
        preview: `${miniPath}LL_infog_abj.jpg`,
        tags: ['journalisme', 'dataviz'],
      },
      {
        name: 'Dataviz pour La Lettura',
        caption: 'Infographie sur les restitutions et le marché d\'art premier pour La Lettura - Corriere della Sera',
        src: `${mapsPath}LL-2_infog_abj.jpg`,
        preview: `${mapsPath}LL-2_infog_abj.jpg`,
        tags: ['journalisme', 'dataviz'],
      },
      {
        name: 'GEO',
        caption: 'Cartographe correspondant pour le magazine GEO',
        src: `${mapsPath}geo_alaska_abj.png`,
        preview: `${miniPath}geo_alaska_abj.jpg`,
        tags: ['journalisme', 'géopolitique', 'tourisme'],
      },
      {
        name: 'GEO Histoire',
        caption: 'Cartographe correspondant pour le magazine GEO Histoire',
        src: `${mapsPath}geo_espagne_abj.png`,
        preview: `${miniPath}geo_espagne_abj.jpg`,
        tags: ['journalisme', 'géopolitique'],
      },
      {
        name: 'POPSU Territoires',
        caption: 'Réalisation de la cartographie pour le compte-rendu de l\'étude <a href=https://www.ecologie.gouv.fr/dossier-presse-etude-exode-urbain-mythe-des-realites>« Exode urbain : un mythe, des réalités »</a>',
        src: `${mapsPath}exodeurb_popsu_abj.png`,
        preview: `${miniPath}exodeurb_popsu_abj.jpg`,
        tags: ['recherche', 'édition', 'urbanisme & architecture'],
      },
      {
        name: 'Le Gouvernail - Viamouv',
        caption: 'Cartographe pour <a href=https://www.legouvernail.net>Le Gouvernail de Viamouv</a>',
        src: `${mapsPath}legouvernail_abj.jpg`,
        preview: `${miniPath}legouvernail_abj.jpg`,
        tags: ['tourisme', 'urbanisme & architecture'],
      },
      {
        name: 'Articles pour CARTO',
        caption: 'Auteur d\'articles pour le magazine CARTO',
        src: `${mapsPath}article_carto_abj.png`,
        preview: `${miniPath}article_carto_abj.jpg`,
        tags: ['journalisme'],
      },
      {
        name: 'Atlas of Design Vol. 6',
        caption: 'Lauréat de <a href=https://atlasofdesign.org>l\'Atlas of Design Vol. 6</a> édité par la North American Cartographic Information Society',
        src: `${mapsPath}atlas1.jpg`,
        preview: `${miniPath}atlas1.jpg`,
        tags: ['édition', 'confinement'],
      },
      {
        name: 'Cartographie ornementale en bois',
        caption: 'Plan de Calais en bois, réalisé avec les ébénistes Simon Bouckson et Arnaud Malras, pour la Fabrique Coopérative Calaisienne La Timbale',
        src: `${mapsPath}calais_bois_abj.jpg`,
        preview: `${miniPath}calais_bois_abj.jpg`,
        tags: ['calais'],
      },
      {
        name: 'Rapport climatique',
        caption: 'Réalisation de la cartographie pour le <a href="http://comite21grandouest.org/grand-ouest/comite21/comite21-en-action.html?id=14621">rapport du GIEC des Pays de la Loire</a>',
        src: `${mapsPath}GIEC-pays-de-la-loire-abj.jpg`,
        preview: `${miniPath}GIEC-pays-de-la-loire-abj.jpg`,
        tags: ['édition', 'recherche', 'urbanisme & architecture'],
      },
      {
        name: 'Infographies pour Jeune Afrique',
        caption: 'Infographe correspondant pour Jeune Afrique',
        src: `${mapsPath}JA-abj.png`,
        preview: `${miniPath}JA-abj.jpg`,
        tags: ['journalisme'],
      },
      {
        name: 'Infographies pour The Africa Report',
        caption: 'Infographe correspondant pour The Africa Report',
        src: `${mapsPath}TAR_infog_abj.png`,
        preview: `${miniPath}TAR_infog_abj.png`,
        tags: ['journalisme', 'dataviz'],
      },
      {
        name: 'Voyages à travers l’Europe humaniste du XVIe siècle',
        caption: 'Parution dans le Bulletin des éditions Les Belles Lettres, accompagnant un article du spécialiste de la Renaissance Jean Céard',
        src: `${mapsPath}belles_lettres_abj.jpg`,
        preview: `${miniPath}belles_lettres_abj.jpg`,
        tags: ['édition'],
      },
      {
        name: "L'eau à Marseille",
        caption: "Carte de diagnostic urbain autour de la problématique de l'eau",
        src: `${mapsPath}Carte_eau_marseille_abj.jpg`,
        preview: `${miniPath}Carte_eau_marseille_abj.png`,
        tags: ['urbanisme & architecture'],
      },
      {
        name: 'Cahier POPSU Métabolisme et Métropole',
        caption: 'Éditions Flammarion Autrement - Cartographies et infographies pour le cahier POPSU Métabolisme et Métropole de Lille',
        src: `${mapsPath}popsu2_abj_site.jpg`,
        preview: `${miniPath}popsu2_abj_site.jpg`,
        tags: ['édition', 'recherche', 'urbanisme & architecture', 'dataviz'],
      },
      {
        name: 'Découvrez Lens-Liévin à vélo !',
        caption: 'Réalisation de 4 plans parcours vélo pour l\'Office de Tourisme de Lens-Liévin',
        src: `${mapsPath}mockup_plans_lens.jpg`,
        preview: `${miniPath}mockup_plans_lens.jpg`,
        tags: ['tourisme'],
      },
      {
        name: 'Plan de communes',
        caption: 'Plan de la commune de Saint-Franc, pour Envergure-be',
        src: `${mapsPath}Saint-Franc_abj.jpg`,
        preview: `${miniPath}Saint-Franc_abj.jpg`,
        tags: ['tourisme', 'urbanisme & architecture'],
      },
      {
        name: "Fronts & frontières dans l'espace du Cône Sud",
        caption: 'Carte scolaire de géographie',
        src: `${mapsPath}frontsfrontieres.jpg`,
        preview: `${miniPath}frontsfrontieres.jpg`,
        tags: ['recherche', 'géopolitique'],
      },
      {
        name: 'Puy Mary',
        caption: 'Essai de carte topographique avec pour sujet un sommet des monts du Cantal ',
        src: `${mapsPath}puymary.jpg`,
        preview: `${miniPath}puymary.jpg`,
        tags: ['tourisme'],
      },
      {
        name: 'Cartographie du Gouvernail de Saint-Dié-des-Vosges : Face A',
        caption: '<span>Face classique : Plan urbain rotatif (Le Gouvernail), avec monuments remarquables illustrés </span> <br> <span style="font-size: 0.75rem">Données utilisées : Plan Cadastral Informatisé (PCI) de la DGFiP via OpenStreetMap </span>',
        src: `${mapsPath}gouvernail_st_die_abj_2.jpg`,
        preview: `${miniPath}gouvernail_st_die_abj_2.jpg`,
        tags: ['tourisme'],
      },
      {
        name: 'Cartographie du Gouvernail de Saint-Dié-des-Vosges : Face B',
        caption: '<span>Face sensible : Plan urbain rotatif (Le Gouvernail), reprenant le travail de concertation auprès des habitants mené par la psychogéographe Anne-Solange Muis</span> <br> <span style="font-size: 0.75rem">Données utilisées : Plan Cadastral Informatisé (PCI) de la DGFiP via OpenStreetMap</span>',
        src: `${mapsPath}gouvernail_st_die_abj_3.jpg`,
        preview: `${miniPath}gouvernail_st_die_abj_3.jpg`,
        tags: ['tourisme'],
      },
      {
        name: 'Calais victorien 2020',
        caption: 'Plan de Calais "à l\'ancienne" vendu en poster dans différentes boutiques de la ville',
        src: `${mapsPath}carte_calais_2020.jpg`,
        preview: `${miniPath}carte_calais_2020.jpg`,
        tags: ['tourisme', 'calais'],
      },
      {
        name: 'Épaves du pas de Calais',
        caption: 'Carte bathymétrique relevant différentes épaves ayant sombrées dans le pas de Calais ',
        src: `${mapsPath}epaves.jpg`,
        preview: `${miniPath}epaves.jpg`,
        tags: ['tourisme', 'calais'],
      },
      {
        name: 'Plan masse',
        caption: 'Urbaniste de formation, je vous accompagne pour réaliser des master plans dans une esthétique précise',
        src: `${mapsPath}petit_courgain_final_abj_site.jpg`,
        preview: `${miniPath}petit_courgain_final_abj_site.jpg`,
        tags: ['calais', 'urbanisme & architecture'],
      },
      {
        name: 'Aménagement du territoire',
        caption: 'Plan d\'étude du Portel, pour le bureau d\'études urbaines COREM',
        src: `${mapsPath}COREM_carto_abj.jpg`,
        preview: `${miniPath}COREM_carto_abj.jpg`,
        tags: ['urbanisme & architecture', 'architecture'],
      },
      {
        name: 'Use-It Calais édition 2021',
        caption: 'Nouvelle édition de la carte touristique collaborative Use-It Calais (à télécharger <a href=https://calaiswood.fr/la-carte-use-it-calais-2/>ici</a>)',
        src: `${mapsPath}UI2_abj.jpg`,
        preview: `${miniPath}UI2_abj.jpg`,
        tags: ['tourisme', 'calais'],
      },
      {
        name: 'Géologie',
        caption: 'Géologie de surface de la France métropolitaine',
        src: `${mapsPath}geologie.jpg`,
        preview: `${miniPath}geologie.jpg`,
        tags: ['recherche'],
      },
      {
        name: 'Nouvelle Zemble',
        caption: 'Essai de carte topographique pour impression en cyanotype',
        src: `${mapsPath}nz-01.png`,
        preview: `${miniPath}nz-01.jpg`,
        tags: [],
      },
      {
        name: 'Vallée de la Dordogne',
        caption: "D'Argentat à Beaulieu - Commande personnelle",
        src: `${mapsPath}correze.jpg`,
        preview: `${miniPath}correze.jpg`,
        tags: ['tourisme'],
      },
      {
        name: 'Animation',
        caption: 'Animation - Calais Nord, vie nocture',
        src: `${mapsPath}neon.gif`,
        preview: `${mapsPath}neon.gif`,
        tags: ['calais'],
      },
      {
        name: 'Use-It Calais face A',
        caption: 'Use-It Calais face A - À télécharger ici : <a href="https://calaiswood.fr/projets/#use-it-calais">https://calaiswood.fr/projets/#use-it-calais</a>',
        src: `${mapsPath}useitcalais1.png`,
        preview: `${miniPath}useitcalais1.jpg`,
        tags: ['tourisme', 'calais'],
      },
      {
        name: 'Use-It Calais face B',
        caption: 'Use-It Calais face B - À télécharger ici : <a href="https://calaiswood.fr/projets/#use-it-calais">https://calaiswood.fr/projets/#use-it-calais</a>',
        src: `${mapsPath}useitcalais2.png`,
        preview: `${miniPath}useitcalais2.jpg`,
        tags: ['tourisme', 'calais'],
      },
      {
        name: 'Îles grecques',
        caption: 'Visualisation 3D à partir de données satellitaires',
        src: `${mapsPath}iles_grecques.jpg`,
        preview: `${miniPath}iles_grecques.jpg`,
        tags: [],
      },
      {
        name: 'Plan de cimetière',
        caption: 'Cimetiere Nord Calais : Plan des sepultures remarquables',
        src: `${mapsPath}cimetiere_nord_calais.png`,
        preview: `${miniPath}cimetiere_nord_calais.jpg`,
        tags: ['tourisme', 'calais'],
      },
      {
        name: 'Carte universitaire',
        caption: 'Cartographie de mémoire de maîtrise',
        src: `${mapsPath}same2.jpg`,
        preview: `${miniPath}same2.jpg`,
        tags: ['recherche'],
      },
      {
        name: 'Carte universitaire',
        caption: 'Cartographie de mémoire de maîtrise',
        src: `${mapsPath}same3.jpg`,
        preview: `${miniPath}same3.jpg`,
        tags: ['recherche'],
      },
      {
        name: 'Carte universitaire',
        caption: 'Cartographie de mémoire de maîtrise',
        src: `${mapsPath}same4.jpg`,
        preview: `${miniPath}same4.jpg`,
        tags: ['recherche'],
      },
      {
        name: 'Le Paris des toilettes publiques',
        caption: 'Le Paris des toilettes publiques - infographie',
        src: `${mapsPath}arthur_beaubois_jude_toilettes_wc_paris.jpg`,
        preview: `${miniPath}arthur_beaubois_jude_toilettes_wc_paris.jpg`,
        tags: ['journalisme', 'dataviz'],
      },
      {
        name: 'Mirror Lakes, Nouvelle-Zélande',
        caption: 'Carte publiée dans le fanzin de cartographie Mercator #2 : Reflet',
        src: `${mapsPath}mirror_lakes_mercator_abj.jpg`,
        preview: `${miniPath}mirror_lakes_mercator_abj.jpg`,
        tags: ['tourisme'],
      },
      {
        name: 'La vie politique de Jean-Jacques Barthe',
        caption: 'Infographie publiée dans Nord Littoral',
        src: `${mapsPath}BARTHE_NL_ABJ.jpg`,
        preview: `${miniPath}BARTHE_NL_ABJ.jpg`,
        tags: ['journalisme', 'dataviz'],
      },
      {
        name: 'Cartographies sur panneaux',
        caption: 'Cartographies sur panneaux pour le POPSU Métropoles de Grenoble (avec <a href="https://figureslibres.cc/">Figures Libres</a> )',
        src: `${mapsPath}popsu-grenoble-abj.jpg`,
        preview: `${mapsPath}popsu-grenoble-abj.jpg`,
        tags: ['recherche', 'urbanisme & architecture'],
      },
      {
        name: 'Mon monde confiné',
        caption: 'Carte s\'étalant sur un cercle de rayon d\'un kilomètre',
        src: `${mapsPath}calais_confiné_abj_site.jpg`,
        preview: `${miniPath}calais_confiné_abj_site.jpg`,
        tags: ['tourisme', 'calais', 'confinement'],
      },
      {
        name: 'Vos mondes confinés',
        caption: 'Carte s\'étalant sur un cercle de rayon d\'un kilomètre',
        src: `${mapsPath}nomain_abj_site.jpg`,
        preview: `${miniPath}nomain_abj_site.jpg`,
        tags: ['tourisme', 'confinement'],
      },
      {
        name: 'Vos mondes confinés - Paris',
        caption: 'Carte s\'étalant sur un cercle de rayon d\'un kilomètre',
        src: `${mapsPath}paris_confine_abj_site.jpg`,
        preview: `${miniPath}paris_confine_abj_site.jpg`,
        tags: ['tourisme', 'confinement'],
      },
    ],
  },
);
